import React, { useState, useEffect } from "react";
import Card from "@mui/material/Card";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import CommentView from "./CommentView";
import CommentsInsert from "./CommentsInsert";
import { comments_list } from "src/api/comments";
import LinearProgress from "@mui/material/LinearProgress";
import Icon from "src/@core/components/icon";
import CommentText from "mdi-material-ui/CommentText";
// ** Third Party Components
import toast from "react-hot-toast";
import moment from "moment-timezone";
const MAX_COMMENTS = 5;

// const _isChapterAvailable = (dripDays, courseAddedAt) => {
//   const avaliableDate = moment.utc(courseAddedAt).add(dripDays, "days");
//   if (moment.utc().isAfter(avaliableDate)) return true;
//   return false;
// };
const _isChapterAvailable = (chapter, courseAddedAt) => {
  //console.log("_isChapterAvailable", chapter, courseAddedAt);
  if (chapter.status_code === 0) return false;
  if (chapter.status_code === 1) return true;

  // Dripping
  if (chapter.status_code === 2 && chapter.drip_days !== undefined) {
    const avaliableDate = moment.utc(courseAddedAt).add(chapter.drip_days, "days");

    if (moment.utc().isAfter(avaliableDate)) return true;
  }

  // Avaliable On
  if (chapter.status_code === 3 && chapter.avaliable_on !== undefined) {
    if (moment.utc().isAfter(chapter.avaliable_on)) return true;
  }

  return false;
};

function Comments({ courseId, chapterId, lessonId, auth, isSmallDevice, userCanReply, activeChapter, courseAddedAt }) {
  const [comments, setComments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showCommentsPart2, setShowCommentsPart2] = useState(false);
  const [tab, setTab] = useState("recents");
  const tabPaneStyle = {
    padding: 0,
    margin: 0,
  };
  useEffect(() => {
    getComments();
  }, [lessonId]);

  const commentsPart1 = comments?.slice(0, MAX_COMMENTS); // ["a", "b"]
  const commentsPart2 = comments?.slice(MAX_COMMENTS + 1); // ["d", "e", "f"]

  const getComments = async (showLoader = true, sort = tab) => {
    if (showLoader) setIsLoading(true);
    const response = await dbGetComments(auth.user, courseId, chapterId, lessonId, sort);
    if (!response.status) {
      toast.error("Oops... Erro ao carregar os comentário...", {
        position: "top-right",
        duration: 5000,
      });
      if (showLoader) setIsLoading(false);
      return;
    }

    setShowCommentsPart2(false);
    setComments(response.data);
    if (showLoader) setIsLoading(false);
  };

  const dbGetComments = (auth, courseId, chapterId, lessonId, order) => {
    return new Promise((resolve) => {
      try {
        comments_list(auth, courseId, chapterId, lessonId, order)
          .then((res) => resolve({ status: true, data: res.data }))
          .catch((err) => resolve({ status: false, data: err }));
      } catch (error) {
        resolve({ status: false, data: error });
      }
    });
  };

  const handleChange = (newValue) => {
    setTab(newValue);
    getComments(true, newValue);
  };

  return (
    <>
      {_isChapterAvailable(activeChapter, courseAddedAt) && (
        <Card className="comments-card" sx={{ pl: 3, pr: 3, mt: 2 }} style={{ borderRadius: 0 }}>
          <div className="comments-head">
            <span className="comments-head__icon">
              <CommentText />
            </span>
            <h4 className="comments-head__title">Comentários</h4>
            {comments.length > 0 && <span className="comments-head__count">{comments.length}</span>}
          </div>
          <Box sx={{ mt: 1, width: "100%", height: 4 }}>{isLoading && <LinearProgress style={{ height: 4 }} color="secondary" />}</Box>

          <div className="comments-sort">
            <button type="button" className={`comments-sort__btn ${tab === "recents" ? "is-active" : ""}`} disabled={isLoading} onClick={() => handleChange("recents")}>
              Mais recentes
            </button>
            <button type="button" className={`comments-sort__btn ${tab === "olds" ? "is-active" : ""}`} disabled={isLoading} onClick={() => handleChange("olds")}>
              Mais antigos
            </button>
            {!isSmallDevice && (
              <button type="button" className={`comments-sort__btn ${tab === "votes" ? "is-active" : ""}`} disabled={isLoading} onClick={() => handleChange("votes")}>
                Mais votados
              </button>
            )}
            {!isSmallDevice && (
              <button type="button" className={`comments-sort__btn ${tab === "comments" ? "is-active" : ""}`} disabled={isLoading} onClick={() => handleChange("comments")}>
                Mais comentários
              </button>
            )}
          </div>
          {/* <TabContext value={tab}>
            <TabList onChange={handleChange} className={`${isSmallDevice ? "mobile-comments-tabs" : ""}`}>
              <Tab value="recents" label="Mais recentes" disabled={isLoading} />
              <Tab value="olds" label="Mais antigos" disabled={isLoading} />
              {!isSmallDevice && <Tab value="votes" label="Mais votados" disabled={isLoading} />}
              {!isSmallDevice && <Tab value="comments" label="Mais comentários" disabled={isLoading} />}
            </TabList>

            <TabPanel style={tabPaneStyle} value="recents"></TabPanel>
            <TabPanel style={tabPaneStyle} value="olds"></TabPanel>
            <TabPanel style={tabPaneStyle} value="votes"></TabPanel>
            <TabPanel style={tabPaneStyle} value="comments"></TabPanel>
          </TabContext> */}

          <Box className="comments-container">
            <Box>
              <CommentsInsert
                disabled={isLoading}
                courseId={courseId}
                chapterId={chapterId}
                lessonId={lessonId}
                auth={auth}
                onAddNewComment={(e) => getComments(false)}
              />
              {/*Zona de inserção de comentários*/}
              {commentsPart1.map((comment) => (
                <CommentView
                  userCanReply={userCanReply}
                  key={comment._id}
                  courseId={courseId}
                  chapterId={chapterId}
                  lessonId={lessonId}
                  auth={auth}
                  comment={comment}
                  onCommentUpdate={(e) => getComments(false)}
                />
              ))}
              {showCommentsPart2 && (
                <>
                  {commentsPart2.map((comment) => (
                    <CommentView
                      userCanReply={userCanReply}
                      key={comment._id}
                      courseId={courseId}
                      chapterId={chapterId}
                      lessonId={lessonId}
                      auth={auth}
                      comment={comment}
                      onCommentUpdate={(e) => getComments(false)}
                    />
                  ))}
                </>
              )}
              {commentsPart2.length > MAX_COMMENTS - 1 && showCommentsPart2 === false && (
                <button type="button" className="comments-more" onClick={() => setShowCommentsPart2(true)}>
                  Ver mais comentários
                </button>
              )}

              {comments.length === 0 && (
                <div className="lesson-state" style={{ paddingTop: 24, paddingBottom: 24 }}>
                  <div className="lesson-state__icon">
                    <CommentText />
                  </div>
                  <h3 className="lesson-state__title">Ainda não existem comentários</h3>
                  <p className="lesson-state__text">Sê a primeira pessoa a comentar e começa um tópico para trocar ideias sobre a aula.</p>
                </div>
              )}
            </Box>
          </Box>
        </Card>
      )}
    </>
  );
}

export default Comments;
